import script from "./ExperienceTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperienceTable.vue?vue&type=script&setup=true&lang=js"

import "./ExperienceTable.vue?vue&type=style&index=0&id=31913852&lang=scss"

const __exports__ = script;

export default __exports__